import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { appService } from '../../../_services/app.service'; 
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe'; 
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-new-issue-modal',
  templateUrl: './new-issue-modal.component.html',
  styleUrls: ['./new-issue-modal.component.scss']
})
export class NewIssueModalComponent {

  @Input() showModal = false;
  @Output() close = new EventEmitter<void>();
  @Output() issueAdded = new EventEmitter<any>();

  previewImages: string[] = [];
  selectedFiles: File[] = [];
  issueTypes: any[] = [];
  UserEmailId : string = '';
  UserFullName : string = '';
  isDragOver = false;
  //userTenantCode : string = '';

  newIssue = {
    name: '',
    email: '',
    description: '',
    tenantCode: '',
    module: '',
    issueType: 'Unknown'
  };

  constructor(
    private issueTypeService: appService,
    private http: HttpClient,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService
  ) {}

  ngOnInit() {

    this.issueTypeService.getAllIssues().subscribe(data => {
      this.issueTypes = data;
    });


    this.UserEmailId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("EmailId")));
    this.UserFullName = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserFullName")));
    this.newIssue.module = (window.location.pathname.split('/')).filter(x => x)[0].toString();
    this.newIssue.tenantCode = window.location.hostname;

    // console.log("User Tenant Code : ",this.newIssue.tenantCode);
    // console.log("User Email : ",this.UserEmailId);
    // console.log("User Full Name : ",this.UserFullName); 
    // console.log("Path Name : ", window.location.pathname.split('/').filter(x => x)[0].toString());
  }

  // ============================
  // IMAGE SELECT
  // ============================
  onFileSelected(event: any, fileInput: any) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      this.selectedFiles.push(file);

      const reader = new FileReader();
      reader.onload = () => this.previewImages.push(reader.result as string);
      reader.readAsDataURL(file);
    }

    fileInput.value = ""; // reset input
  }


  // ============================
  // DRAG IMAGE SELECT
  // ============================
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  // ============================
  // DRAG IMAGE LEAVE
  // ============================
  onDragLeave(event: DragEvent) {
    this.isDragOver = false;
  }

  // ============================
  // DROP IMAGE
  // ============================
  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;

    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      this.readFiles(files);
    }
  }

  onPaste(event: ClipboardEvent) {
    const items = event.clipboardData.items;

    if (!items) return;

    Array.from(items).forEach(item => {
      if (item.type.startsWith("image")) {
        const file = item.getAsFile();
        if (file) {
          this.selectedFiles.push(file);

          const reader = new FileReader();
          reader.onload = () => {
            this.previewImages.push(reader.result as string);
          };
          reader.readAsDataURL(file);
        }
      }
    });
  }



  readFiles(files: FileList) {
    Array.from(files).forEach((file: File) => {
      this.selectedFiles.push(file);

      const reader = new FileReader();
      reader.onload = () => {
        this.previewImages.push(reader.result as string);
      };
      reader.readAsDataURL(file);
    });
  }


  // ============================
  // REMOVE IMAGE
  // ============================
  removeImage(index: number) {
    this.previewImages.splice(index, 1);
    this.selectedFiles.splice(index, 1);
  }

  // ============================
  // SAVE ISSUE (WITH IMAGES)
  // ============================
  saveNewIssue() {


  const formData = new FormData();
  formData.append('name', this.UserFullName);
  formData.append('email', this.UserEmailId);
  formData.append('description', this.newIssue.description);
  formData.append('tenantCode', this.newIssue.tenantCode);
  formData.append('module', this.newIssue.module);
  formData.append('issueType', 'Unknown');
  
  //Appending selected files properly;
  this.selectedFiles.forEach((file) => {
    formData.append("files",file); //Yaha par key 'files' hai;
  })


    this.http.post("https://help.ifreightbox.net/api/values/PostNewIssue", formData)
    .subscribe({
      next: (res) => {
        alert("Inserted Successfully!");
        this.issueAdded.emit(res);
        this.closeModal();
      },
      error: err => {
        console.error("Error:", err);
        alert("Error: " + JSON.stringify(err));
      }
    });
}

  // ============================
  // RESET FORM
  // ============================
  clearData() {
    this.newIssue = {
      name: '',
      email: '',
      description: '',
      tenantCode: this.newIssue.tenantCode,
      module: this.newIssue.module, //Keeping it same as it is
      issueType: 'Unknown'
    };
    this.previewImages = [];
    this.selectedFiles = [];
  }

  closeModal() {
    this.showModal = false;
    this.clearData();
    this.close.emit();
  }

}
